const ENCRYPTION_KEY = process.env.VITE_ENCRYPTION_KEY;

export const encryptData = (data: string): string => {
  if (!data) {
    console.error("Cannot encrypt empty data");
    return "";
  }

  if (!ENCRYPTION_KEY) {
    console.error("Encryption key is missing");
    return data;
  }

  try {
    // Simple XOR encryption (you may want to use a more robust encryption in production)
    const encrypted = data
      .split("")
      .map((char) =>
        String.fromCharCode(char.charCodeAt(0) ^ ENCRYPTION_KEY.charCodeAt(0))
      )
      .join("");
    return btoa(encrypted); // Base64 encode the result
  } catch (error) {
    console.error("Encryption failed:", error);
    // Return original data instead of potentially corrupted data
    return data;
  }
};

export const decryptData = (encryptedData: string): string => {
  if (!encryptedData) {
    console.error("Cannot decrypt empty data");
    return "";
  }

  if (!ENCRYPTION_KEY) {
    console.error("Encryption key is missing");
    return encryptedData;
  }

  try {
    // Validate that the input is valid base64
    if (!/^[A-Za-z0-9+/=]+$/.test(encryptedData)) {
      throw new Error("Invalid base64 input");
    }

    const decoded = atob(encryptedData); // Base64 decode
    return decoded
      .split("")
      .map((char) =>
        String.fromCharCode(char.charCodeAt(0) ^ ENCRYPTION_KEY.charCodeAt(0))
      )
      .join("");
  } catch (error) {
    console.error("Decryption failed:", error);
    throw new Error("Failed to decrypt token");
  }
};
